import Layout from '@/layout' //布局页
const state = {}

const mutations = {
    SET_POSTSINFO(state, data) {
        state.conglomerate = data
    }
};

const actions = {
    queryCodeByType({ commit }) {
        commit('SET_POSTSINFO', {})
    }
};

/**
 * pid children
 * array
 */
export function fn(jsonData, type) {
    // console.log(type)
    var datalist = []
    if (type == "menu") {
        jsonData.forEach(item => {
            if (item.ismenu == 1 && item.status == "1") {
                datalist.push(item)
            }
        })
    } else {
        datalist = jsonData
    }
    // //取得顶级的数据
    var resultObj = []
    var baseNode = datalist.filter((element) => {
        element.component = mapComponent().get(element.name)
        return element.pid == 0;
    })
    resultObj.push(...baseNode)
    var data = getChildren(resultObj, datalist, type);

    return data;
}

//遍历子级节点
export function getChildren(nodeList, jsonData, type) {
    nodeList.forEach(elemet => {
        elemet.children = jsonData.filter(item => {
            item.label = item.title
            if (!item.label) {
                item.label = item.name
            }

            let name = item.name;
            if (type == 'menu') {
                if (name.indexOf('?') >= 0) {
                    name = name.split('?')[0];
                }
                item.component = mapComponent().get(name);
                item.path = name;
                item.meta = {
                    'title': item.title,
                    'icon': item.icon,
                };
            }
            return item.pid == elemet.id;
        })
        if (elemet.children.length > 0) {
            getChildren(elemet.children, jsonData)
        }
    })
    return nodeList;
}

//获取路由与页面对应
export function mapComponent() {
    var map = new Map()
        //数据上报
    map.set('/index', Layout);
    map.set('/createReport', () =>
        import ('@/views/datareport/createReport.vue')); //发起上报
    map.set('/datareport', () =>
        import ('@/views/datareport/datareport.vue')); //数据上报
    map.set('/dataSTA', () =>
        import ('@/views/datareport/datareportCount.vue')); //上报统计
    map.set('/StaReportTask', () =>
        import ('@/views/datareport/StaReportTask.vue')); //上报汇总
    //首页数据管理
    map.set('/homeInfo', Layout);
    map.set('/noticeList', () =>
        import ('@/views/homePageManage/noticeManage.vue')); //通知公告
    map.set('/meetingList', () =>
        import ('@/views/homePageManage/meetingList.vue')); //会议培训
    map.set('/trendsList', () =>
        import ('@/views/homePageManage/trendsListManage.vue')); //行业动态
    map.set('/introductionManage', () =>
        import ('@/views/homePageManage/contentIntroduction.vue')); //中心简介
    map.set('/imageManage', () =>
        import ('@/views/homePageManage/imageManage.vue')); //图片管理
    //基础信息管理
    map.set('/baseInfo', Layout);
    map.set('/organization', () =>
        import ('@/views/baseInfoManage/organization.vue')); //机构管理
    map.set('/userList', () =>
        import ('@/views/baseInfoManage/personalManage.vue')); //人员管理
    // map.set('/templateList', () =>
    //     import ('@/views/templateManagement/templateManagement.vue')); //模板维护
    //系统管理
    map.set('/systemInfo', Layout);
    map.set('/role', () =>
        import ('@/views/systemManage/role.vue')); //角色管理
    map.set('/rules', () =>
        import ('@/views/systemManage/power.vue')); //人员权限管理

    return map;
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}